module.exports = __webpack_public_path__ + "fonts/bc46786.otf";